/**
 * Client entry point
 */

import React from 'react';
import ReactDOMClient from 'react-dom/client';

import config from './config';
import App from './App';
import { configureStore } from './store';
import '../Intl/setup';

// PWA Offline support: https://github.com/NekR/offline-plugin
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime';
import { setAppSSRMode } from './modules/App/AppActions';
import { hardReloadForStaleApp, installChunkLoadRecovery } from './util/staleCache';

if(process.env.NODE_ENV === 'production') {
    OfflinePluginRuntime.install({
        onUpdateReady() {
            // New assets downloaded — activate the waiting service worker
            OfflinePluginRuntime.applyUpdate();
        },
        onUpdated() {
            // New SW is active; reload so the page uses the fresh precache
            hardReloadForStaleApp('sw');
        },
    });
    installChunkLoadRecovery();
}

// Initialize store
const store = configureStore(window.__INITIAL_STATE__);
// Allow the passed state to be garbage-collected
delete window.__INITIAL_STATE__

const container = document.getElementById('root');

// Set as not SSR
store.dispatch(setAppSSRMode(false))

const root = ReactDOMClient.hydrateRoot(container, <App store={store} />);

// For hot reloading of react components
if(module.hot) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default; // eslint-disable-line global-require
        root.render(<NextApp store={store} />);
    });
}
